
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IPagination } from '@/types';
import { UserModule } from '@/store/modules/user';
import { getSchedulingList, addGroupScheduling, editGroupScheduling, delGroupScheduling, delSchedulingShifts, startScheduling, schedulingShiftsUser, getSchedulingShiftsUser } from '@/api/groupScheduling';

import DialogSetStaff from './components/setStaff.vue';
import DialogDept from '@/components/DeptDialog/index.vue';
import DialogSetShifts from './components/setShifts.vue';

@Component({
  name: 'SchedulingList',
  components: {
    DialogDept,
    DialogSetShifts,
    DialogSetStaff
  }
})
export default class extends Vue {
  private formSearch: any = {
    name: ''
  }
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private tableData: any = []
  private listLoading = false;
  private groupDisable = false
  private groupForm = {
    name: '',
    department: ''
  }

  private shiftsOperate = 1

  private dialogSetStaffVisible = false;
  private dialogSetShiftsVisible=false;

  created() {
    this.getAuthGroup();
  }

  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getAuthGroup();
  }

  handlePageSizeChange(size: number) {
    this.pagination.currentPage = 1;
    this.pagination.pageSize = size;
    this.getAuthGroup();
  }

  // 搜索
  private handleSearch() {
    this.pagination.currentPage = 1;
    this.getAuthGroup();
  }

  // 清空
  private handleClear() {
    this.formSearch.name = '';
    this.pagination.currentPage = 1;
    this.getAuthGroup();
  }

  private getAuthGroup() {
    this.listLoading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      group_scheduling_name: this.formSearch.name
    };
    getSchedulingList(params).then(res => {
      this.listLoading = false;
      if (res.data) {
        this.tableData = res.data.list;
        for (let i = 0; i < this.tableData.length; i++) {
          if (parseInt(this.tableData[i].state) === 1) {
            this.tableData[i].isOpened = true
          } else {
            this.tableData[i].isOpened = false
          }
        }
        this.pagination.total = res.data.count;
        this.pagination.currentPage = +res.data.page_current;
        this.pagination.pageSize = +res.data.page_size;
      } else {
        this.pagination.total = 0
        this.tableData = [];
      }
    }).catch(err => {
      this.pagination.total = 0
      this.tableData = [];
      this.listLoading = false;
      let msg = err.msg;
    });
  }
  private editorData:any={}
  private schedulingHandle(val: any) {
    this.departmentVisible = true;
    if (val) {
      this.titleProp = '编辑组';
      this.editorData = val;
      this.radioSelect = {
        groupName: val.group_name,
        dept_id: val.department_id
      };
    } else {
      this.titleProp = '添加组';
      this.editorData = {};
      this.radioSelect = {
        groupName: ''
      };
    }
  }

  private departmentVisible = false
  private deptType = 2
  private enterType = 1
  private titleProp='添加组'
  private radioSelect:any={}

  private departmentDialogClose(val: any) {
    this.departmentVisible = val;
  }
  private departmentSelected(val: any) {
    this.radioSelect = val;
    this.GroupScheduling();
  }
  private GroupScheduling() {
    let pamars:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    pamars.group_name = this.radioSelect.groupName;
    pamars.department_id = this.radioSelect.dept_id;
    pamars.department_name = this.radioSelect.name;
    if (this.editorData && this.editorData.id) {
      pamars.id = this.editorData.id;
      editGroupScheduling(pamars).then((res:any) => {
        this.showSuccessMsg(res.msg);
        this.departmentVisible = false;
        this.getAuthGroup();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    } else {
      addGroupScheduling(pamars).then((res:any) => {
        this.showSuccessMsg(res.msg);
        this.departmentVisible = false;
        this.getAuthGroup();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
  }

  private itemData:any={}
  private deleteGroupHandle(val:any) {
    this.itemData = val;
    this.showConfirmMsg('确认删除该组吗?', 1);
  }
  private startHandle(val:any) {
    this.itemData = val;
    if (parseInt(val.state) === 1) {
      this.showConfirmMsg('确认禁用该组吗?', 2);
    } else {
      this.showConfirmMsg('确认启用该组吗?', 2);
    }
  }

  // 班次
  private shiftsClose(val:any) {
    this.dialogSetShiftsVisible = val;
  }
  private confirm() {
    this.getAuthGroup();
  }
  private addShiftsHandle(val:any) {
    this.itemData = val;
    this.itemData.groupId = val.id;
    this.shiftsOperate = 1;
    this.dialogSetShiftsVisible = true;
  }
  private editShiftsHandle(val:any, val2:any) {
    this.itemData = val;
    this.itemData.groupId = val2.id;
    this.shiftsOperate = 2;
    this.dialogSetShiftsVisible = true;
  }

  private deleteShiftsHandle(val:any) {
    this.itemData = val;
    this.showConfirmMsg('确认删除该班次吗?', 3);
  }
  // 设置人员
private selectUserData:any=[]

private settingStaffHandle(val: any, Prow:any) {
  this.itemData = val;
  this.itemData.dept_id = Prow.department_id;
  this.getSchedulingShiftsUser();
}
private getSchedulingShiftsUser() {
  let pamars:any = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId
  };
  pamars.shifts_id = this.itemData.id;
  getSchedulingShiftsUser(pamars).then((res:any) => {
    if (res.data) {
      this.selectUserData = res.data.list;
    } else {
      this.selectUserData = [];
    }
    this.dialogSetStaffVisible = true;
  }).catch(err => {
    let msg = err.msg;
    this.selectUserData = [];
    this.dialogSetStaffVisible = true;
  });
}
private selectUser(val:any) {
  this.selectUserData = val;
  this.setUser(val);
}
private closeHandle(val: any) {
  this.dialogSetStaffVisible = val;
}

private setUser(user:any) {
  let pamars:any = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId
  };
  pamars.shifts_id = this.itemData.id;
  pamars.group_id = this.itemData.group_id;
  pamars.shifts_user = JSON.stringify(user);
  schedulingShiftsUser(pamars).then((res:any) => {
    this.showSuccessMsg(res.msg);
    this.getAuthGroup();
    this.dialogSetStaffVisible = false;
  }).catch(err => {
    this.showErrorMsg(err.msg);
  });
}

private showConfirmMsg(message: any, type:number) {
  this.$confirm(message, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    this.del(type);
  }).catch(() => {

  });
}
private del(type:number) {
  let pamars:any = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId
  };
  switch (type) {
    case 1:
      pamars.id = this.itemData.id;
      delGroupScheduling(pamars).then((res:any) => {
        this.showSuccessMsg(res.msg);
        this.departmentVisible = false;
        this.getAuthGroup();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
      break;
    case 2:
      pamars.id = this.itemData.id;
      if (parseInt(this.itemData.state) === 1) {
        pamars.state = '0';
      } else {
        pamars.state = '1';
      }
      startScheduling(pamars).then((res:any) => {
        this.showSuccessMsg(res.msg);
        this.departmentVisible = false;
        this.getAuthGroup();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
      break;
    case 3:
      pamars.shifts_id = this.itemData.id;
      delSchedulingShifts(pamars).then((res:any) => {
        this.showSuccessMsg(res.msg);
        this.departmentVisible = false;
        this.getAuthGroup();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
      break;
  }
}
private showErrorMsg(msg: string) {
  this.$notify({
    title: '提示',
    message: msg,
    offset: 100,
    type: 'error'
  });
}
private showSuccessMsg(msg: string) {
  this.$notify({
    title: '提示',
    message: msg,
    offset: 100,
    type: 'success'
  });
}
}
